import { Component, Input, OnChanges, ElementRef, ViewChild } from '@angular/core';

@Component({
    selector: 'sbw-validation-summary',
    templateUrl: './validation-summary.component.html',
    styleUrls: ['./validation-summary.component.css']
})
export class ValidationSummaryComponent implements OnChanges {
    @ViewChild('scrollTarget', { static: true }) scrollTarget: ElementRef;

    ngOnChanges(): void {
        if (this.errorList && this.errorList.length) this.scrollTarget.nativeElement.scrollIntoView()
    }

    @Input() errorList: string[]

    constructor() { }

}
